import { lazy } from 'react';

/** Una pantalla por feature, cargada bajo demanda (cada una es su propio chunk). */
export const InicioPage = lazy(() => import('@/features/inicio/pages/InicioPage'));
export const PreciosPage = lazy(() => import('@/features/precios/pages/PreciosPage'));
export const HistoricoPage = lazy(() => import('@/features/historico/pages/HistoricoPage'));
export const ComparadorPage = lazy(() => import('@/features/comparador/pages/ComparadorPage'));
export const TendenciasPage = lazy(() => import('@/features/tendencias/pages/TendenciasPage'));
export const CalculadoraPage = lazy(() => import('@/features/calculadora/pages/CalculadoraPage'));
export const AlertasPage = lazy(() => import('@/features/alertas/pages/AlertasPage'));
export const NotificacionesPage = lazy(() => import('@/features/alertas/pages/NotificacionesPage'));
export const CuentaPage = lazy(() => import('@/features/cuenta/pages/CuentaPage'));
export const EntrarPage = lazy(() => import('@/features/cuenta/pages/EntrarPage'));
export const RegistroPage = lazy(() => import('@/features/cuenta/pages/RegistroPage'));
export const RecuperarPage = lazy(() => import('@/features/cuenta/pages/RecuperarPage'));
export const RestablecerPage = lazy(() => import('@/features/cuenta/pages/RestablecerPage'));
export const VerificarPage = lazy(() => import('@/features/cuenta/pages/VerificarPage'));
export const FuentesPage = lazy(() => import('@/features/fuentes/pages/FuentesPage'));
export const AdminPage = lazy(() => import('@/features/admin/pages/AdminPage'));
export const AjustesPage = lazy(() => import('@/features/ajustes/pages/AjustesPage'));
export const NoticiasPage = lazy(() => import('@/features/noticias/pages/NoticiasPage'));
export const AcercaPage = lazy(() => import('@/features/acerca/pages/AcercaPage'));
